// @flow
import React from 'react'
import Cookie from 'js-cookie'
import withPage from 'server/withPage'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import LoginPage from 'components/pages/LoginPage'
import { bindActionCreators } from 'redux'
import { setUIState, containerIds } from 'redux/modules/ui'
import { viewerFragment } from 'api/fragments'
import { authUrlWithQuery } from 'helpers/format'
import { checkTokenExpired } from 'helpers/auth'
import AccountUseCase, {
  type AccountUseCaseType,
  AccountUseCaseActionsBridge,
} from 'usecases/AccountUseCase'
import { amplitudeLogEvent } from 'helpers/amplitude'
import Path from 'routes/path'
import { wwwUrl } from 'frontend_core/dist/helpers/url'

type PropTypes = {
  config: {
    URL: string,
  },
  accountUseCase: AccountUseCaseType,
  data: {
    viewer: {},
  },
}

class LoginPageContainer extends React.Component<PropTypes> {
  componentDidMount() {
    const { accountUseCase, location, actions, restClient } = this.props
    accountUseCase.checkVerifyEmailIsConfirm()
    if (Cookie.get('sm_xct')) {
      accountUseCase.loginIdP()
      if (location.search.indexOf('signup=true') !== -1) {
        // SNSのsignupから戻ってきた時に同意確認のAPIをポストする
        actions.snsSignupAgreement({
          restClient,
          token: Cookie.get('sm_xct'),
        })
      }
    }

    accountUseCase.checkErrorMessage()
    amplitudeLogEvent('Start Login')
  }

  componentWillUnmount() {
    const { accountUseCase } = this.props
    accountUseCase.clearAccount()
  }

  render() {
    const { config, data } = this.props
    return (
      <LoginPage
        title={i18n.t('server.account.login.title')}
        description={i18n.t('server.account.login.description')}
        linkCanonical={wwwUrl(Path.login())}
        config={config}
        currentUser={data?.viewer}
        googleAuthUrl={authUrlWithQuery(config.URL, 'google')}
        isLoading={Cookie.get('sm_xct')}
      />
    )
  }
}

const pageQuery = gql`
query LoginPage {
  viewer {
    ${viewerFragment}
  }
}`
const withData = graphql(pageQuery, {
  skip: checkTokenExpired(),
  options: props => {
    const variables = {}
    return { variables }
  },
})

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = Object.assign(AccountUseCaseActionsBridge)
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withPage(
  AccountUseCase(LoginPageContainer),
  mapStateToProps,
  mapDispatchToProps,
  {
    graphql: withData,
  },
)
